import { UserSettingDetailPage } from "@/features/user-setting/pages/UserSettingDetail";

const UserSettingDetail = () => {
  return <UserSettingDetailPage />;
};

export default UserSettingDetail;
